











import { defineComponent, PropType, ref } from '@vue/composition-api'

import OutputConditionGroup from '@/components/organisms/h/outputCond/OutputConditionGroup.vue'
import {
  outputConditionGroupOutputCondition,
  outputCondUseInfoList,
  disposalRateConfOutputCondition,
} from '@/types/entities'

export default defineComponent({
  components: {
    OutputConditionGroup,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
  },
  setup(_, context) {
    const changeOutputCondition = (
      params: outputConditionGroupOutputCondition
    ) => {
      const cond: disposalRateConfOutputCondition = {
        extractTarget: params.extractTarget || [],
      }
      context.emit('change-output-condition', cond)
    }
    const radioDisabled = true
    return { changeOutputCondition, radioDisabled }
  },
})
